import { JSX, ReactNode, createContext, useContext } from 'react';

// Host-app navigation for link-outs (transaction details, eLinx history,
// support tickets, ...). The host owns its routes: the portal passes
// history.push (state included — some target pages read router state, e.g.
// bank-verify details), the embedded app posts a message to its parent, which
// can only carry the path. Undefined = the host can't navigate (no handler
// wired) and link-outs render as plain text.
export type HostNavigate = (path: string, state?: unknown) => void;

const HostNavigationContext = createContext<HostNavigate | undefined>(undefined);

export function HostNavigationProvider({
  onNavigate,
  children,
}: {
  onNavigate?: HostNavigate;
  children: ReactNode;
}): JSX.Element {
  return <HostNavigationContext.Provider value={onNavigate}>{children}</HostNavigationContext.Provider>;
}

// Feature-internal only (per shared rules: exported components take props;
// everything under ContactDetailView may read this instead).
export function useHostNavigate(): HostNavigate | undefined {
  return useContext(HostNavigationContext);
}
